export default __webpack_public_path__ + "apartment-description-highlights.3ueW7.jpg";